import filter from "lodash/filter";
import map from "lodash/map";
import iconIdBase64 from "./iconIdBase64";
import initializeIconIdBase64 from "./initializeIconIdBase64";
import initializeShowNamesNodeStyle from "./initializeShowNamesNodeStyle";
import webGL2NodeStyles from "./webGL2NodeStyles";
export default async (tags) => {
    await initializeIconIdBase64(iconIdBase64);
    const unloadedTags = filter(tags, tag => !webGL2NodeStyles.nodeIdMap[tag.Id]);
    if (!unloadedTags.length)
        return;
    await Promise.all(map(unloadedTags, initializeShowNamesNodeStyle));
};
